<template>
    <div class="feedback-page">
        <!-- Logo -->
        <div class="logo-container">
            <img src="../../../assets/image/LOGO.png" alt="峰岭科技" class="logo">
        </div>

        <!-- 主标题 -->
        <div class="main-title">诚挚邀请您留下宝贵意见</div>

        <!-- 表单区域 -->
        <div class="form-container">
            <el-form :model="feedbackForm" :rules="rules" ref="feedbackForm" class="feedback-form">
                <!-- 姓名 -->
                <el-form-item prop="name">
                    <el-input
                        v-model="feedbackForm.name"
                        placeholder="姓名"
                        class="form-input"
                    ></el-input>
                </el-form-item>

                <!-- 联系方式 -->
                <el-form-item prop="mobile">
                    <el-input
                        v-model="feedbackForm.mobile"
                        placeholder="联系方式"
                        class="form-input"
                    ></el-input>
                </el-form-item>

                <!-- 单位 -->
                <el-form-item prop="company">
                    <el-input
                        v-model="feedbackForm.company"
                        placeholder="单位"
                        class="form-input"
                    ></el-input>
                </el-form-item>

                <!-- 意见或建议 -->
                <el-form-item prop="feedback">
                    <div class="feedback-label-with-bg">
                        <span>意见或建议</span>
                        <img src="../../../assets/image/fd_start.png" alt="*" class="required-icon">
                    </div>
                    <el-input
                        type="textarea"
                        v-model="feedbackForm.feedback"
                        :rows="6"
                        placeholder="意见一经采纳 更有好礼相送"
                        class="form-textarea"
                        maxlength="500"
                        show-word-limit
                    ></el-input>
                </el-form-item>

                <!-- 图片上传 -->
                <el-form-item>
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                        :limit="1"
                    >
                    <i class="el-icon-picture-outline"></i>
                    </el-upload>
                    <div class="upload-tip">支持上传文件，单个文件不超过5MB</div>
                </el-form-item>

                <!-- 提交按钮 -->
                <el-form-item>
                    <el-button type="primary" @click="submitFeedback" class="submit-btn">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {submitFeedbackAPI} from "@/assets/API/user";

export default {
    name: 'Feedback',
    data() {
        return {
            feedbackForm: {
                name: '',
                mobile: '',
                company: '',
                feedback: ''
            },
            fileList: [],
            uploadFile: null, // 存储上传的文件
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                feedback: [
                    { required: true, message: '请输入您的意见或建议', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        // 文件上传前的校验
        beforeUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!');
                return false;
            }

            // 可以添加文件类型校验
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }

            return true;
        },

        // 文件改变时的处理
        handleFileChange(file, fileList) {
            // 限制只能上传一个文件
            if (fileList.length > 1) {
                this.$message.error('只能上传一个文件!');
                return;
            }

            // 校验文件大小
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!');
                this.fileList = [];
                this.uploadFile = null;
                return;
            }

            this.fileList = fileList;
            this.uploadFile = file.raw; // 保存原始文件对象
        },

        // 移除文件
        handleFileRemove(file, fileList) {
            this.fileList = fileList;
            this.uploadFile = null;
        },

        // 提交反馈
        submitFeedback() {
            this.$refs.feedbackForm.validate((valid) => {
                if (valid) {
                    // 创建 FormData 对象
                    const formData = new FormData();

                    // 添加表单字段
                    formData.append('name', this.feedbackForm.name);
                    formData.append('mobile', this.feedbackForm.mobile);
                    formData.append('company', this.feedbackForm.company); // 可选字段
                    formData.append('feedback', this.feedbackForm.feedback);

                    // 添加文件（如果有）
                    if (this.uploadFile) {
                        formData.append('file', this.uploadFile);
                    }

                    // TODO: 调用提交反馈的API
                    // 示例：
                  submitFeedbackAPI(formData).then(res => {
                        if (res.code === 200) {
                            this.$message.success('感谢您的宝贵意见！');
                            this.$refs.feedbackForm.resetFields();
                            this.fileList = [];
                            this.uploadFile = null;
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err => {
                        this.$message.error('提交失败，请稍后重试');
                    });
                } else {
                    this.$message.error('请填写完整信息');
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.feedback-page {
    min-height: calc(100vh - 60px);
    background: linear-gradient(180deg,
        rgba(223, 236, 246, 1) 0%,
        rgba(240, 245, 250, 1) 50%,
        rgba(255, 255, 255, 1) 100%
    );
    padding: 40px 20px;
    padding-top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .logo-container {
        position: fixed;
        top: 80px;
        right: 80px;
        z-index: 1000;

        .logo {
            height: 60px;
            width: auto;
            object-fit: contain;
        }
    }

    .main-title {
        font-size: 32px;
        font-weight: 400;
        color: rgba(56, 56, 56, 1);
        text-align: center;
        margin-top: 100px;
        margin-bottom: 40px;
        letter-spacing: 2px;
    }

    .form-container {
        width: 100%;
        max-width: 600px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 16px;
        padding: 40px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .feedback-form {
            ::v-deep .el-form-item {
                margin-bottom: 24px;
            }

            .form-input {
                ::v-deep .el-input__inner {
                    height: 50px;
                    line-height: 50px;
                    border-radius: 8px;
                    border: 1px solid rgba(230, 230, 230, 1);
                    background: rgba(250, 250, 250, 1);
                    font-size: 16px;
                    color: rgba(56, 56, 56, 1);

                    &::placeholder {
                        color: rgba(180, 180, 180, 1);
                    }

                    &:focus {
                        border-color: rgba(35, 173, 222, 1);
                        background: #FFFFFF;
                    }
                }
            }

            .feedback-label {
                font-size: 14px;
                color: rgba(56, 56, 56, 1);
                margin-bottom: 8px;
            }

            .feedback-label-with-bg {
                //display: inline-flex;
                width: 25%;
                align-items: center;
                //gap: 6px;
                padding: 2px 8px;
                background: linear-gradient(90deg, rgba(35, 143, 232, 1) 30.09%, rgba(35, 143, 232, 0) 100%);
                border-radius: 4px;
                margin-bottom: 0;

                span {
                    font-size: 16px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 23.17px;
                    color: rgba(255, 255, 255, 1);
                }

                .required-icon {
                    width: 18px;
                    height: 18px;
                    object-fit: contain;
                    transform: translateY(-15px);
                }
            }

            .form-textarea {
                ::v-deep .el-textarea__inner {
                    border-radius: 8px;
                    border: 1px solid rgba(230, 230, 230, 1);
                    background: rgba(250, 250, 250, 1);
                    font-size: 16px;
                    color: rgba(56, 56, 56, 1);
                    padding: 12px;

                    &::placeholder {
                        color: rgba(180, 180, 180, 1);
                    }

                    &:focus {
                        border-color: rgba(35, 173, 222, 1);
                        background: #FFFFFF;
                    }
                }
            }

            .upload-demo {
                ::v-deep .el-upload {
                    width: 100px;
                    height: 100px;
                    border: 1px dashed rgba(220, 220, 220, 1);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        border-color: rgba(35, 173, 222, 1);
                    }

                    .el-icon-picture-outline {
                        font-size: 32px;
                        color: rgba(180, 180, 180, 1);
                    }
                }

                ::v-deep .el-upload-list__item {
                    width: 100px;
                    height: 100px;
                    border-radius: 8px;
                }
            }

            .upload-tip {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                margin-top: 8px;
                line-height: 1.5;
            }

            .submit-btn {
                width: 100%;
                height: 50px;
                background: linear-gradient(90deg,
                    rgba(64, 158, 255, 1) 0%,
                    rgba(35, 173, 222, 1) 100%
                );
                border: none;
                border-radius: 25px;
                font-size: 18px;
                font-weight: 500;
                color: #FFFFFF;
                letter-spacing: 2px;
                margin-top: 20px;
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(35, 173, 222, 0.4);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .feedback-page {
        padding-top: 40px;

        .logo-container {
            top: 70px;
            right: 20px;

            .logo {
                height: 40px;
            }
        }

        .main-title {
            font-size: 24px;
            margin-top: 60px;
        }

        .form-container {
            padding: 24px;
        }
    }
}
</style>
